// extracted by mini-css-extract-plugin
export default {"PurchasedQuantity":"PurchasedQuantity-styles__PurchasedQuantity__XO34h","PurchasedQuantity__Label":"PurchasedQuantity-styles__PurchasedQuantity__Label__e0ipd"};